import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const presentation = {
  current: { label: 'Subscription payment current', color: '#198754' },
  overdue: { label: 'Subscription payment overdue', color: '#e74c3c' },
  unknown: { label: 'Subscription payment status unconfirmed', color: '#ad6800' },
};

export default function ClientSubscriptionIndicator({ status, legacyIcon }) {
  const { t } = useTranslation();
  // Older API releases only provide the numeric current/overdue flag.
  const resolved = status === undefined
    ? ({ 0: 'overdue', 1: 'current' }[legacyIcon])
    : status;
  const view = presentation[resolved];
  if (!view) return null;
  const label = t(view.label);
  return <span role="img" aria-label={label} title={label} style={{ color: view.color }}>
    <i className="fa fa-undo" aria-hidden="true" />
  </span>;
}

ClientSubscriptionIndicator.propTypes = {
  status: PropTypes.oneOf(['current', 'overdue', 'unknown']),
  legacyIcon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
